import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';

import { DISCOUNTED_PARAM } from './discountedParam';
import type { ProductRangeFilter } from './interfaces';

export { DISCOUNTED_PARAM };

/** Largest value the catalog accepts in a price range filter (a signed 32-bit integer). */
const DISCOUNT_PRICE_CAP = 2147483647;

/** In major units: the catalog store converts filters to minor units for the request. */
export const DISCOUNTED_FILTER: ProductRangeFilter = {
  from: 0.01,
  to: Math.floor(DISCOUNT_PRICE_CAP / 100),
};

export const isDiscountedFilterEnabled = () =>
  company.is(CompanyName.DubaiExpress);

export const parseDiscountedFilter = (
  searchParams: URLSearchParams,
): ProductRangeFilter | undefined =>
  isDiscountedFilterEnabled() && searchParams.get(DISCOUNTED_PARAM) === '1'
    ? DISCOUNTED_FILTER
    : undefined;
